<template>
  <RemotePaginatedList :hide-search="hideSearch"
                       :filter-options="filterOptions"
                       :headers="headers"
                       multi-sort
                       :data-url="dataUrl"
                       data-key="templates"
                       :refresh-trigger.sync="innerRefreshTrigger"
                       :items-per-page="20"
                       v-bind="$attrs">
    <template #item.type="{value}">
      {{ $t(`email_template_types.${value}`) }}
    </template>
    <template v-slot:item.actions="{item}">
      <v-row>
        <v-col>
          <font-awesome-icon icon="edit"
                             @click="editItem(item)"></font-awesome-icon>
        </v-col>
      </v-row>
    </template>
  </RemotePaginatedList>
</template>

<script>
import {computed, onMounted, ref, watch} from '@vue/composition-api'
import RemotePaginatedList from "@/components/RemotePaginatedList";

export default {
  name: 'EmailTemplateList',
  components: {RemotePaginatedList},
  props: {
    dataUrl: String,
    hideSearch: Boolean,
    refreshTrigger: Boolean,
  },
  setup(props, {root, emit}) {
    const refresh = function () {
      innerRefreshTrigger.value = true;
    };
    onMounted(() => {
      refresh();
    });

    watch(() => props.refreshTrigger, (newValue) => {
      if (newValue) {
        refresh();
        emit('update:refresh-trigger', false);
      }
    })

    // Filter
    const filterOptions = ref([]);

    // Data Table
    const headers = ref([
      {text: root.$t('admin_notification_template.type'), value: 'type', sortable: false},
      {text: root.$t('admin_notification_template.email_subject'), value: 'email_subject', sortable: false},

      {text: '', value: 'actions', sortable: false},
    ]);
    const innerRefreshTrigger = ref(false);

    const editItem = function (item) {
      emit('edit', item);
    };


    return {
      filterOptions,

      headers,
      innerRefreshTrigger,

      editItem,
    }
  }
}
</script>
